import Enum from "../../../enums/Enum";

const EnumRotation = new Enum({
    FIXED: "Fixed",
    IN_ROTATION: "In Rotation",
    FLOATING: "Floating"
});

export default EnumRotation;
